(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore', 'jquery', 'torso/modules/Behavior'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('underscore'), require('jquery'), require('backbone-torso/modules/Behavior'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_, $, TorsoBehavior) {
  'use strict';

  var STATIC_IMAGE_RESOURCE_URL = '/static-content-resources/images/';
  var PREVIEW_CSS_IDENTIFIER = 'data-id="preview-css"';

  /**
   * Behavior that allows the view have its images temporarily changed for a preview when changing images admin-side.
   *
   * @class PreviewBehavior
   * @constructor
   * @param options {Object}
   *   @param options._setPreviewOptions {Function} a function to use when setting preview options.  Will run in the context of the behavior.
   */
  return TorsoBehavior.extend({
    /**
     * @method initialize
     * @param attributes {Object} - initial state (unused).
     * @param options {Object}
     *   @param options._setPreviewOptions {Function} a function to use when setting preview options.  Will run in the context of the behavior.
     * @override
     */
    initialize: function(attributes, options) {
      if (options && _.isFunction(options._setPreviewOptions)) {
        this._setPreviewOptions = _.bind(options._setPreviewOptions, this);
      }
    },

    /**
     * @method prerender
     * @override
     */
    prerender: function() {
      if (this.view.isPreview()) {
        var previewCssBundleSelector = '[' + PREVIEW_CSS_IDENTIFIER + ']';
        $('head').find(previewCssBundleSelector).remove();
      }
    },

    /**
     * Inserts link into view for preview css bundle
     * @method postrender
     * @override
     */
    postrender: function() {
      var cssBundleName = this.get('cssBundleName');
      if (this.view.isPreview() && cssBundleName) {
        $('head').append('<link ' + PREVIEW_CSS_IDENTIFIER + ' rel="stylesheet" href="/static-content/css/content/' + cssBundleName + '">');
      }
    },

    /**
     * @method postinitialize
     * @override
     */
    postinitialize: function() {
      this.on('change:imageUrlsMap change:cssVariables', this.view.render, this.view);
      this.listenTo(this.view, 'render:complete', this._disableForPreview);
    },

    /**
     * Updates all anchors to not do their default navigate.
     * @method _disableForPreview
     * @private
     */
    _disableForPreview: function() {
      if (this.view.isPreview()) {
        this.view.$el
          .find('a')
          .each(function() {
            this.onclick = function () {
              return false;
            };
          });
        this.view._disableForPreview();
      }
    },

    /**
     * Method meant to be overridden by the behavior definition to perform additional logic (like chaining the call to child views).
     * @method mixin._setPreviewOptions
     * @param options {Object}
     *   @param [options.imageFileNames=undefined] {Object} the image id to image filename of the image to use instead of the default images.
     *   @param [options.cssBundleName=undefined] {String} the name of the bundle to use
     */
    _setPreviewOptions: _.noop,

    mixin: {
      /**
       * @method mixin.setPreviewOptions
       * @param options {Object}
       *   @param [options.imageFileNames=undefined] {Object} the image id to image filename of the image to use instead of the default images.
       *   @param [options.cssBundleName=undefined] {String} the name of the bundle to use
       */
      setPreviewOptions: function(options) {
        options = options || {};
        this.set('isPreview', true);

        var imageFileNames = _.omit(options, 'cssBundleName');
        var imageUrlsMap = this.get('imageUrlsMap') || {};
        _.each(imageFileNames, function(imageFileName, imageName) {
          imageUrlsMap[imageName] = STATIC_IMAGE_RESOURCE_URL + imageFileName;
        });
        this.set('imageUrlsMap', imageUrlsMap);

        var cssBundleName = options.cssBundleName;
        this.set('cssBundleName', cssBundleName);

        if (_.isFunction(this.view._setPreviewOptions)) {
          this.view._setPreviewOptions(options);
        }
        if (_.isFunction(this._setPreviewOptions)) {
          this._setPreviewOptions(options);
        }
      },

      /**
       * Method meant to be overridden by views to perform additional logic (like chaining the call to child views).
       * @method mixin._setPreviewOptions
       * @param options {Object}
       *   @param [options.imageFileNames=undefined] {Object} the image id to image filename of the image to use instead of the default images.
       *   @param [options.cssBundleName=undefined] {String} the name of the bundle to use
       */
      _setPreviewOptions: _.noop,

      /**
       * @method isPreview
       * @return {Boolean} true if this is using a preview image, false otherwise.
       */
      isPreview: function() {
        return this.get('isPreview');
      },

      /**
       * @method isEmptyImagePreview
       * @param imageName {String} the name of the image to check if it is empty.
       * @return {Boolean} true if this is an image preview and the image preview is empty, false otherwise.
       */
      isEmptyImagePreview: function(imageName) {
        var imageUrlsMap = this.get('imageUrlsMap');
        var imageUrl = imageUrlsMap && imageUrlsMap[imageName];
        var hasImageUrl = imageUrl && imageUrl !== STATIC_IMAGE_RESOURCE_URL;
        return this.view.isPreview() && !hasImageUrl;
      },

      /**
       * @method isImagePreviewNotSet
       * @param imageName {String} the name of the image to check if it is not set.
       * @return {Boolean} true if this is an image preview and the image preview is not set, false otherwise.
       */
      isImagePreviewNotSet: function(imageName) {
        var imageUrlsMap = this.get('imageUrlsMap');
        var imageUrl = imageUrlsMap && imageUrlsMap[imageName];
        return this.view.isPreview() && _.isUndefined(imageUrl);
      },

      /**
       * Allow the view to have its own logic for disabling links that goes beyond the default of disabling onclick
       * of anchor tags.
       * @method mixin._disableForPreview
       * @private
       */
      _disableForPreview: _.noop
    }
  });
}));
